import React, { Component } from 'react';
import _ from 'lodash';
import HeaderComponent from './HeaderComponent';
import { RedocStandalone } from 'redoc';
import { Option } from './types';
const configuration = require('./config.json');

const VERSION_QUERY_PARAM = 'version';

type Props = {};

type State = {
    listOptions: Option[];
    specFiles: {
        [keys: number]: string;
    };
    selectedOption: null | Option;
    selectedSpecFile: null | string;
};

class RedocComponent extends Component {
    constructor(props: Props) {
        super(props);
        const listOptions: Option[] = [];
        const specFiles: { [k: number]: string } = {};
        let defaultOption: Option | null = null;
        let defaultSpecFile: string | null = null;

        if (_.has(configuration, this.getEnv())) {
            _.sortBy(configuration[this.getEnv()], ['showOrder']).forEach((version, idx) => {
                const thisOption: Option = { value: version.version, label: version.title };
                listOptions.push(thisOption);
                specFiles[version.version] = version.specfile;
                if (idx === 0) {
                    defaultOption = thisOption;
                    defaultSpecFile = version.specfile;
                }
            });
        }

        const requestedVersion = this.readVersionFromUrl();
        const matchedOption =
            requestedVersion !== null
                ? listOptions.find((opt) => opt.value === requestedVersion) ?? null
                : null;

        this.state = {
            listOptions,
            specFiles,
            selectedOption: matchedOption ?? defaultOption,
            selectedSpecFile: matchedOption ? specFiles[matchedOption.value] : defaultSpecFile,
        };

        // Normalize URL: if the requested version was missing/invalid, reflect the
        // default we actually rendered so refresh/share matches what the user sees.
        const effective = matchedOption ?? defaultOption;
        if (effective) {
            this.writeVersionToUrl(effective.value, { replace: true });
        }

        this.handleChange = this.handleChange.bind(this);
    }

    state: State = {
        listOptions: [],
        specFiles: {},
        selectedOption: null,
        selectedSpecFile: null,
    };

    getEnv() {
        if (document.location.href.includes('apidocs.wyscout.com')) {
            return 'prod';
        } else if (document.location.href.includes('apidocsrc.wyscout.com')) {
            return 'rc';
        }

        return 'beta';
    }

    readVersionFromUrl(): number | null {
        const params = new URLSearchParams(window.location.search);
        const raw = params.get(VERSION_QUERY_PARAM);
        if (raw === null) return null;
        const parsed = Number(raw);
        return Number.isInteger(parsed) ? parsed : null;
    }

    writeVersionToUrl(version: number, opts: { replace?: boolean } = {}) {
        const url = new URL(window.location.href);
        url.searchParams.set(VERSION_QUERY_PARAM, String(version));
        const next = url.pathname + url.search + url.hash;
        if (opts.replace) {
            window.history.replaceState(null, '', next);
        } else {
            window.history.pushState(null, '', next);
        }
    }

    handleChange(selectedOption: Option) {
        const selectedFile = this.state.specFiles[selectedOption.value];
        this.setState({
            selectedOption: selectedOption,
            selectedSpecFile: selectedFile,
        });
        this.writeVersionToUrl(selectedOption.value);
    }

    render() {
        return (
            <div>
                <HeaderComponent
                    options={this.state.listOptions}
                    handleChange={this.handleChange}
                    selectedOption={this.state.selectedOption}
                />
                {this.state.selectedSpecFile && (
                    <RedocStandalone
                        specUrl={process.env.PUBLIC_URL + this.state.selectedSpecFile}
                    />
                )}
            </div>
        );
    }
}
export default RedocComponent;
